import { Subject } from 'rxjs';
function getPulseAsyncContext() {
    const g = (typeof globalThis === 'object' ? globalThis : {});
    const store = g.__pulseAsyncContextStore;
    return store?.getStore();
}
export function getPulseInstance() {
    const instance = getPulseAsyncContext() ?? globalThis.pulse?.θ?.i;
    return instance;
}
export async function getPulseDelayedInstance() {
    const instance = getPulseInstance();
    if (instance) {
        return instance;
    }
    if (!globalThis.pulse.θ) {
        throw new Error('Pulse sdk is not initialized!');
    }
    return new Promise((resolve) => {
        globalThis.pulse.θ.ready.push((pulse) => resolve(pulse));
    });
}
export function delayedMethod(key) {
    return async function (...args) {
        const instance = (await getPulseDelayedInstance());
        // eslint-disable-next-line prefer-spread
        return instance[key].apply(instance, args);
    };
}
export function delayedObservable(key) {
    return function (...args) {
        const subject = new Subject();
        getPulseDelayedInstance().then(function (instance) {
            const child = instance[key].apply(instance, args);
            child.subscribe(subject);
        });
        return subject.asObservable();
    };
}
export function delayedSubject(key) {
    return function (...args) {
        const subject = new Subject();
        getPulseDelayedInstance().then(function (instance) {
            const child = instance[key].apply(instance, args);
            child.subscribe(subject);
        });
        return subject;
    };
}
//# sourceMappingURL=instance.js.map